import { Option } from "fp";

import { useBaseURL } from "~/Context";
import * as Log from "~/Log";
import { Time } from "~/Time";

import * as Entry from "./Entry";

export * as Entry from "./Entry";
export { RevisionStatus } from "./RevisionStatus";

export namespace State {
  export type State = { readonly entries: Entry.State.State };
  export const initial = (): State => ({ entries: Entry.State.initial() });
}

export namespace Link {
  export const useHREF = (route: Log.Route): Option<string> =>
    Option.fromNullable(
      Log.Data.useActiveLogWhen(route, {
        unavailable: () => undefined,
        available: href(useBaseURL()),
      })
    );

  const href = (baseURL: string) => (log: Log.Identity): string => {
    const date = Time.DateTime.toISOWithoutTime(log);
    return `${baseURL}/time-tracking/employee/${log.driver.id}/${date}`;
  };
}
